import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AfitdTypography from './AfitdTypography';
import cx from 'clsx';

const styles = theme => ({
    root: { marginRight: '8px', padding: '9px 10px', borderRadius: '4px', background: theme.palette.secondary.main },
    grey: { background: '#F0F2F6' },
    extraPadding: { paddingLeft: 20, paddingRight: 20 },
});

const AfitdMultiSelectLovValueBlock = props => {
    const { classes, isHidden, label, value, isGrey, isExtraPadding, ...otherProps } = props;
    const fontColor = isGrey ? null : { clsWhiteColor: true };
    const fontWeight = isGrey ? { clsSkinnyBold: true } : null;

    if (isHidden) {
        return null;
    } else {
        return (
            <div className={cx(classes.root, { [classes.grey]: isGrey, [classes.extraPadding]: isExtraPadding })} {...otherProps}>
                <AfitdTypography variant="body2" {...fontColor} {...fontWeight} value={value} />
            </div>
        );
    }
};

export default withStyles(styles)(AfitdMultiSelectLovValueBlock);
